export default __webpack_public_path__ + "media/images/bord-error1-033deeb67225aa2f6e424196fb02255d.png";